var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 215,
    viewBox: "0 0 167 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2256 52.3599V0H82.7946V25.9483H55.0397V52.3599H28.2256Z",
    fill: "#D63C5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2256 215V162.64H82.7946V188.588H55.0397V215H28.2256Z",
    fill: "#D63C5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.363 -0.000133514L137.363 52.3597L82.7943 52.3597L82.7943 26.4115L110.549 26.4115L110.549 -0.000135823L137.363 -0.000133514Z",
    fill: "#D63C5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.363 162.64L137.363 215L82.7943 215L82.7943 189.052L110.549 189.052L110.549 162.64L137.363 162.64Z",
    fill: "#D63C5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.549 81.5516H82.7944V134.375H167V81.5516H138.304V107.963H110.549V81.5516Z",
    fill: "#D63C5E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 80.1615,
    width: 55.5099,
    height: 54.6767,
    fill: "#D63C5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f217962cc2e2bf646a1006d88227dceb.svg";
export { ForwardRef as ReactComponent };